import { useState } from "react";

export function useSelection(idProp: string = "id") {
	const [selected, setSelected] = useState(new Set<string>());

	function toggle(id: string) {
		setSelected(prev => {
			const next = new Set(prev);
			if (next.has(id)) next.delete(id);
			else next.add(id);
			return next;
		});
	}

	function toggleAll(items: any[]) {
		setSelected(prev => {
			const allSelected = items.length > 0 && items.every(r => prev.has(r[idProp]));
			if (allSelected) {
				return new Set<string>();
			} else {
				return new Set(items.map(r => r[idProp]));
			}
		});
	}

	function clear() {
		setSelected(new Set());
	}

	return { selected, toggle, toggleAll, clear };
}
